import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_txn_line_fact_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  report_type: fromDatatype.TextDatatypeInterface;
  report_code: fromDatatype.TextDatatypeInterface;
  report_option: fromDatatype.TextDatatypeInterface;
  param_code: fromDatatype.TextDatatypeInterface;
  param_name: fromDatatype.TextDatatypeInterface;
  param_type: fromDatatype.TextDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.TextDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_line: fromDatatype.GuidDataFieldInterface;
  date1_year: fromDatatype.NumericDatatypeInterface;
  date1_month: fromDatatype.NumericDatatypeInterface;
  date1_day: fromDatatype.NumericDatatypeInterface;
  date1_hour: fromDatatype.NumericDatatypeInterface;
  date1_minute: fromDatatype.NumericDatatypeInterface;
  date2_year: fromDatatype.NumericDatatypeInterface;
  date2_month: fromDatatype.NumericDatatypeInterface;
  date2_day: fromDatatype.NumericDatatypeInterface;
  date2_hour: fromDatatype.NumericDatatypeInterface;
  date2_minute: fromDatatype.NumericDatatypeInterface;
  net_qty_debit: fromDatatype.NumericDatatypeInterface;
  net_qty_credit: fromDatatype.NumericDatatypeInterface;
  bal_qty: fromDatatype.NumericDatatypeInterface;
  txn_created: fromDatatype.TimestampTzDatatypeInterface;
  txn_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  net_amt_debit: fromDatatype.NumericDatatypeInterface;
  net_amt_credit: fromDatatype.NumericDatatypeInterface;
  bal_amt: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.TextDatatypeInterface;
  client_source: fromDatatype.TextDatatypeInterface;
  unit_cost_method: fromDatatype.TextDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_amount: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_amount: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.TimestampTzDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  serial_number: fromDatatype.TextDatatypeInterface;
  client_value: fromDatatype.TextDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  property_json: any;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_inv_txn_line_fact_RowClass implements bl_inv_txn_line_fact_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  report_type: fromDatatype.TextDatatypeInterface;
  report_code: fromDatatype.TextDatatypeInterface;
  report_option: fromDatatype.TextDatatypeInterface;
  param_code: fromDatatype.TextDatatypeInterface;
  param_name: fromDatatype.TextDatatypeInterface;
  param_type: fromDatatype.TextDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.TextDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_line: fromDatatype.GuidDataFieldInterface;
  date1_year: fromDatatype.NumericDatatypeInterface;
  date1_month: fromDatatype.NumericDatatypeInterface;
  date1_day: fromDatatype.NumericDatatypeInterface;
  date1_hour: fromDatatype.NumericDatatypeInterface;
  date1_minute: fromDatatype.NumericDatatypeInterface;
  date2_year: fromDatatype.NumericDatatypeInterface;
  date2_month: fromDatatype.NumericDatatypeInterface;
  date2_day: fromDatatype.NumericDatatypeInterface;
  date2_hour: fromDatatype.NumericDatatypeInterface;
  date2_minute: fromDatatype.NumericDatatypeInterface;
  net_qty_debit: fromDatatype.NumericDatatypeInterface;
  net_qty_credit: fromDatatype.NumericDatatypeInterface;
  bal_qty: fromDatatype.NumericDatatypeInterface;
  txn_created: fromDatatype.TimestampTzDatatypeInterface;
  txn_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  net_amt_debit: fromDatatype.NumericDatatypeInterface;
  net_amt_credit: fromDatatype.NumericDatatypeInterface;
  bal_amt: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.TextDatatypeInterface;
  client_source: fromDatatype.TextDatatypeInterface;
  unit_cost_method: fromDatatype.TextDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_amount: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_amount: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.TimestampTzDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  serial_number: fromDatatype.TextDatatypeInterface;
  client_value: fromDatatype.TextDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  property_json: any;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
